import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import CustomPieChart from '../Charts/CustomPieChart'
import CustomBarChart from '../Charts/CustomBarChart'
import DetectDevice from '../../components/DeviceDetection'

const InsightResponseDetails = (props) => {
  const [chartData, setChartData] = useState([])
  const [responseText, setResponseText] = useState('')
  const colors = ['#5FAE8A', '#DADADA', '#CBD5E1', '#E07A73']

  if (!String.format) {
    String.format = function (format) {
      var args = Array.prototype.slice.call(arguments, 1)
      return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match
      })
    }
  }

  const { loading } = useQuery(props.response.query, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (props.response.chartType !== '') {
        let chartDataArr = []
        chartDataArr.push(organizeData(data))
        setChartData(chartDataArr)
      } else {
        organizeData(data)
      }
    },
  })
  const organizeData = (data) => {
    if (props.questionKey === 'highestClick_platform') {
      return process_highestClick_platform(data.click.stats)
    } else if (props.questionKey === 'totalConversions_allCampaigns') {
      return process_totalConversions_allCampaigns(
        data.myCampaigns.campaignDatas
      )
    } else if (props.questionKey === 'highestConversion_device') {
      return process_highestConversion_device(data.conversion.stats)
    } else if (props.questionKey === 'mostConversion_day') {
      return process_mostConversion_day(data.conversion.stats)
    } else if (props.questionKey === 'highestConversion_campaign') {
      return process_highestConversion_campaign(data.myCampaigns.campaignDatas)
    } else if (props.questionKey === 'highestConversion_location') {
      return process_highestConversion_location(data.conversion.stats)
    } else if (props.questionKey === 'highestConversionRate_campaign') {
      return process_highestConversionRate_campaign(
        data.myCampaigns.campaignDatas
      )
    } else if (props.questionKey === 'highestConversion_hour') {
      return process_highestConversion_hour(data.conversion.stats)
    } else if (props.questionKey === 'averageConversionRate_allCampaigns') {
      return process_averageConversionRate_allCampaigns(
        data.myCampaigns.campaignDatas
      )
    } else if (props.questionKey === 'highestConversionRate_device') {
      return process_highestConversionRate_device(data)
    }
  }
  const process_highestClick_platform = (data) => {
    let chartDataTemp = []
    let othersCount = 0
    data.forEach((k, i) => {
      if (i < 3) {
        let position = k.position.charAt(0).toUpperCase() + k.position.slice(1)
        if (i === 0) {
          setResponseText(String.format(props.response.text, position, k.count))
        }
        chartDataTemp.push({ name: position, value: k.count, fill: colors[i] })
      } else {
        othersCount = othersCount + k.count
      }
    })
    if (othersCount > 0) {
      chartDataTemp.push({
        name: 'Others',
        value: othersCount,
        fill: colors[colors.length - 1],
      })
    }
    return chartDataTemp
  }
  const process_totalConversions_allCampaigns = (data) => {
    let totalConversions = 0
    data.forEach((t) => {
      totalConversions = totalConversions + t.conversions
    })
    setResponseText(String.format(props.response.text, totalConversions))
    return null
  }
  const process_highestConversion_device = (data) => {
    let chartDataTemp = []
    let deviceData = {}
    data.forEach((k, i) => {
      let deviceName = DetectDevice(k.position).name
      if (deviceData[deviceName]) {
        deviceData[deviceName] = deviceData[deviceName] + k.count
      } else {
        deviceData[deviceName] = k.count
      }
    })
    let index = 0
    Object.keys(deviceData).forEach((t) => {
      chartDataTemp.push({ name: t, value: deviceData[t], fill: colors[index] })
      index = index + 1
    })
    chartDataTemp.sort(function (a, b) {
      return b.value - a.value
    })
    setResponseText(
      String.format(
        props.response.text,
        chartDataTemp[0].name,
        chartDataTemp[0].value
      )
    )
    return chartDataTemp
  }
  const process_mostConversion_day = (data) => {
    let chartDataTemp = []
    let othersCount = 0
    data.forEach((k, i) => {
      if (i < 3) {
        let position = k.position.charAt(0).toUpperCase() + k.position.slice(1)
        if (i === 0) {
          setResponseText(String.format(props.response.text, position, k.count))
        }
        chartDataTemp.push({ name: position, value: k.count, fill: colors[i] })
      } else {
        othersCount = othersCount + k.count
      }
    })
    if (othersCount > 0) {
      chartDataTemp.push({
        name: 'Others',
        value: othersCount,
        fill: colors[colors.length - 1],
      })
    }
    return chartDataTemp
  }
  const process_highestConversion_campaign = (data) => {
    data.sort(function (a, b) {
      return b.conversions - a.conversions
    })
    setResponseText(
      String.format(
        props.response.text,
        data[0].campaignName,
        data[0].conversions
      )
    )
    return null
  }
  const process_highestConversion_location = (data) => {
    setResponseText(
      String.format(props.response.text, data[0].position, data[0].count)
    )
    return null
  }
  const process_highestConversionRate_campaign = (data) => {
    data.forEach((t) => {
      if (t.clicks > 0) {
        t.conversionRate = ((t.conversions * 100) / t.clicks).toFixed(2)
      } else {
        t.conversionRate = 0
      }
    })
    data.sort(function (a, b) {
      return b.conversionRate - a.conversionRate
    })
    setResponseText(
      String.format(
        props.response.text,
        data[0].campaignName,
        data[0].conversionRate
      )
    )
    return null
  }
  const process_highestConversion_hour = (data) => {
    let chartDataTemp = []
    let othersCount = 0
    data.forEach((k, i) => {
      if (i < 3) {
        const d = new Date()
        d.setHours(k.position, 0, 0)
        let position = d.toLocaleString('en-US', {
          hour: 'numeric',
          hour12: true,
        })
        if (i === 0) {
          setResponseText(String.format(props.response.text, position, k.count))
        }
        chartDataTemp.push({ name: position, value: k.count, fill: colors[i] })
      } else {
        othersCount = othersCount + k.count
      }
    })
    if (othersCount > 0) {
      chartDataTemp.push({
        name: 'Others',
        value: othersCount,
        fill: colors[colors.length - 1],
      })
    }
    return chartDataTemp
  }
  const process_averageConversionRate_allCampaigns = (data) => {
    let totalConversionRate = 0
    data.forEach((t) => {
      if (t.clicks > 0) {
        t.conversionRate = ((t.conversions / t.clicks) * 100).toFixed(2)
        totalConversionRate =
          Number(totalConversionRate) + Number(t.conversionRate)
      } else {
        t.conversionRate = 0
      }
    })
    let avgConversionRate = (totalConversionRate / data.length).toFixed(2)
    setResponseText(String.format(props.response.text, avgConversionRate))
    return null
  }
  const process_highestConversionRate_device = (data) => {
    let chartDataTemp = []
    let deviceData = {}
    data.click.stats.forEach((k, i) => {
      let deviceName = DetectDevice(k.position).name
      if (deviceData[deviceName]) {
        deviceData[deviceName].clicks = deviceData[deviceName].clicks + k.count
      } else {
        deviceData[deviceName] = { conversions: 0 }
        deviceData[deviceName].clicks = k.count
      }
    })
    data.conversion.stats.forEach((k, i) => {
      let deviceName = DetectDevice(k.position).name
      if (deviceData[deviceName]) {
        deviceData[deviceName].conversions =
          deviceData[deviceName].conversions + k.count
      }
    })
    let index = 0
    Object.keys(deviceData).forEach((t) => {
      let conversionRate =
        deviceData[t].clicks !== 0
          ? Math.round(
              ((deviceData[t].conversions * 100) / deviceData[t].clicks) * 100
            ) / 100
          : 0
      chartDataTemp.push({
        name: t,
        value: conversionRate,
        fill: colors[index],
      })
      index = index + 1
    })
    chartDataTemp.sort(function (a, b) {
      return b.value - a.value
    })
    setResponseText(
      String.format(
        props.response.text,
        chartDataTemp[0].name,
        chartDataTemp[0].value
      )
    )
    return chartDataTemp
  }
  return loading ? (
    <></>
  ) : (
    <div className="rounded p-2 bg-gray-100 w-full lg:w-2/3">
      <div className="text-onTrack-smoke text-start mx-6 mb-6 mt-2 text-2xl">
        {responseText}
      </div>
      <div className="grid gap-2">
        <div className="grid w-full">
          {chartData.map((t, i) => (
            <div key={i}>
              <div className="flex justify-center">
                {props.response.chartType === 'pie' && (
                  <CustomPieChart width={500} height={275} data={t} />
                )}
                {props.response.chartType === 'bar' && (
                  <CustomBarChart data={t} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default InsightResponseDetails
